<template>
  <el-container>
     <div class="navbar">
    

      <el-row   :gutter="24" > 
		
		 <el-col :span="6"><div class="grid-content "> <cl-breadcrumb /> </div></el-col>
		
   		<el-col :span="18"><div class="right-menu"><cl-header></cl-header></div></el-col>
		
    

    	</el-row>
     </div>

     
    <el-container>
      
      <cl-side-bar></cl-side-bar>
      <keep-alive>
        <router-view />
      </keep-alive>
    </el-container>
    <el-footer height="0"></el-footer>
  </el-container>
</template>

<script>

export default {
  components: {
   
    'cl-breadcrumb': () => import('./components/breadcrumb'),
    'cl-header': () => import('./components/header'),
    'cl-side-bar': () => import('./components/sidebar')
  }
}
</script>
<style scoped>

	.el-container {
		padding: 0px;
		margin: 0px;
    height: 100%;
    width: 100%;

	}

  .navbar {
  height: 30px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}


  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
 .right-menu {
    float: right;
    border-radius: 4px;
    min-height: 36px;
    margin-right: 8px;
 }

</style>
